import { RecordActions } from "./types";
var initialState = {
    myGroupIds: [],
    myOrderIds: [],
};
export function recordReducer(state, action) {
    var _a, _b, _c, _d, _e;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case RecordActions.ADD_SUBMITTED_FORM:
            if (action.payload.eventNumber === ((_a = state.questionSubmitHistory) === null || _a === void 0 ? void 0 : _a.eventNumber)) {
                if (!state.questionSubmitHistory.submittedForms.includes(action.payload.formId)) {
                    return Object.assign({}, state, {
                        questionSubmitHistory: {
                            eventNumber: action.payload.eventNumber,
                            submittedForms: state.questionSubmitHistory.submittedForms.concat([action.payload.formId]),
                        },
                    });
                }
                else {
                    return state;
                }
            }
            else {
                return Object.assign({}, state, {
                    questionSubmitHistory: {
                        eventNumber: action.payload.eventNumber,
                        submittedForms: [action.payload.formId],
                    },
                });
            }
        case RecordActions.ADD_GROUP_ID:
            var newGroupIds = (_c = (_b = state.myGroupIds) === null || _b === void 0 ? void 0 : _b.concat()) !== null && _c !== void 0 ? _c : [];
            if (!newGroupIds.includes(action.payload)) {
                newGroupIds.push(action.payload);
                return Object.assign({}, state, { myGroupIds: newGroupIds });
            }
            return state;
        case RecordActions.ADD_ORDER_ID:
            var newOrderIds = (_e = (_d = state.myOrderIds) === null || _d === void 0 ? void 0 : _d.concat()) !== null && _e !== void 0 ? _e : [];
            if (!newOrderIds.includes(action.payload)) {
                newOrderIds.push(action.payload);
                return Object.assign({}, state, { myOrderIds: newOrderIds });
            }
            return state;
        case RecordActions.CLEAR_SUBMITTED_FORMS:
            return Object.assign({}, state, {
                questionSubmitHistory: {
                    eventNumber: action.payload,
                    submittedForms: [],
                },
            });
        default:
            return state;
    }
}
